export const storage = {
  get<T>(key: string): T | null {
    try {
      const raw = localStorage.getItem(key)
      return raw ? JSON.parse(raw) as T : null
    } catch {
      return null
    }
  },

  // 保存に成功すれば true、容量超過などで失敗(握りつぶし)した場合は false を返す。
  // 戻り値を見ない既存呼び出しはそのまま動く（後方互換）。
  set(key: string, value: unknown): boolean {
    try {
      localStorage.setItem(key, JSON.stringify(value))
      return true
    } catch {
      console.warn(`Failed to save to localStorage: ${key}`)
      return false
    }
  },

  remove(key: string): void {
    localStorage.removeItem(key)
  },

  getString(key: string): string | null {
    return localStorage.getItem(key)
  },

  setString(key: string, value: string): void {
    localStorage.setItem(key, value)
  },

  clear(): void {
    localStorage.clear()
  },
}
